import { useEffect, useState } from "react";

export default function useReducedMotion() {
	const [reduced, setReduced] = useState(() => {
		if (typeof window === "undefined" || !window.matchMedia) return false;
		return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	});

	useEffect(() => {
		if (!window.matchMedia) return;
		const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
		const onChange = (e) => setReduced(e.matches);
		mql.addEventListener?.("change", onChange);
		return () => mql.removeEventListener?.("change", onChange);
	}, []);

	return reduced;
}
